(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {

  const stickyBar = document.getElementById("ProductBottomSticky");
  const stickyButton = document.getElementById("StickyAddToCart");
  const addToCartSection = document.querySelector(".product-form__buttons-top");

  if (!stickyBar || !stickyButton || !addToCartSection) return;

  /* Show/Hide Sticky Bar */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      stickyBar.classList.toggle("show", !entry.isIntersecting);
    });
  }, {
    threshold: 0.1
  });

  observer.observe(addToCartSection);

  /* Update Button Text on Variant Change */
  document.addEventListener("variant:change", (event) => {
    const variant = event.detail.variant;
    if (!variant) {
      stickyButton.disabled = true;
      stickyButton.textContent = "Unavailable";
      return;
    }
    if (!variant.available) {
      stickyButton.disabled = true;
      stickyButton.textContent = "Sold Out";
      return;
    }
    stickyButton.disabled = false;
    if (
      variant.inventory_management &&
      variant.inventory_policy === "continue" &&
      variant.inventory_quantity <= 0
    ) {
      stickyButton.textContent = "Pre-order";
    } else {
      stickyButton.textContent = "Add to Cart";
    }
  });

  /* Sticky Add to Cart */
  stickyButton.addEventListener("click", () => {
    const submitButton = document.querySelector(
      ".product-form__submit"
    );
    if (!submitButton || submitButton.disabled) return;
    submitButton.click();
  });

});

document.addEventListener("DOMContentLoaded", () => {

  const thumbSlider = document.querySelector(".left-thumbnail-slider .thumbnail-list");
  if (!thumbSlider) return;

  const mainGallery = document.querySelector(".product__media-list");
  if (!mainGallery) return;

  function updateHeight() {
      thumbSlider.style.height = mainGallery.offsetHeight + "px";
  }

  updateHeight();

  const observer = new ResizeObserver(updateHeight);
  observer.observe(mainGallery);

  window.addEventListener("resize", updateHeight);

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  function updateSlideshowHeight() {
    const header = document.querySelector('.section-header, header');
    const announcement = document.querySelector('.announcement-bar');

    const headerHeight = header ? header.offsetHeight : 0;
    const announcementHeight = announcement ? announcement.offsetHeight : 0;

    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`
    );

    document.documentElement.style.setProperty(
      '--announcement-height',
      `${announcementHeight}px`
    );
  }

  updateSlideshowHeight();

  window.addEventListener('resize', updateSlideshowHeight);

});

  } catch(e) { console.error(e); }
})();
})();
